import * as React from "react";
import "./style.css";
import config from "../../../../utils/config";
import request from "../../../../utils/request";
import * as utils from '../../../../utils/utils';
import Toast from "../../../../components/popup/toast";

interface IFormFields {
    produc_name: string;
    quantity: string;
    unit: string;
    mailbox: string;
    contact_name: string;
    company_name: string;
    telephone_no: string;
    address: string;
    message: string;
    shopId: string | number;
}

interface IState extends IFormFields {
    toastText: string;
    toastVisible: boolean;
}

interface IProps {
    goodsId ? : number | string
    goodsName ? : string
    quantity ? : string
}

export default class RequirementsForm extends React.Component < IProps, IState > {
    private toastTimer: any;
    private initState: IState;

    public constructor(props: IProps) {
        super(props);
        this.state = {
            toastText: "", // 提示文本
            toastVisible: false, // 提示框可视化
            produc_name: "",
            quantity: "",
            unit: "KG",
            mailbox: "",
            contact_name: "",
            company_name: "",
            telephone_no: "",
            message: "",
            address: "",
            shopId: ''
        };

        this.initState = { ...this.state };
    }

    public componentDidMount() {
        this.getShopId()
        this.setState({
            produc_name: this.props.goodsName!,
            quantity: this.props.quantity!
        })
    }

    public render() {
        const {
            produc_name,
            contact_name,
            company_name,
            mailbox,
            message,
            quantity,
            telephone_no,
            unit,
            address,
        } = this.state;

        return (
            <div className="xunpanCon" id="requirementsform">
        <form method="post" onSubmit={this.formSubmitHandle}>
          <div className="lytop">
            <h3>Release product requirements</h3>
          </div>
          <div className="ipt-con">
            <div className="lxdh">
              <span>Product Description：</span>
              <textarea
                name="produc_name"
                value={produc_name}
                cols={30}
                rows={10}
                placeholder="Please describe the main performance of the product to be tested."
                onChange={this.formComponentChange}
                maxLength={2000}
              ></textarea>
            </div>
            <div className="lxdh">
              <span>Quantity：</span>
              <input
                style={{ width: "39%" }}
                type="text"
                className="order-searchinput"
                name="quantity"
                value={quantity}
                onChange={this.formComponentChange}
                maxLength={300}
              />
              <select
                name="unit"
                value={unit}
                className="port_s js_select2"
                onChange={this.formComponentChange}
              >
                <option value="KG">KG</option>
                <option value="G">G</option>
                <option value="L">L</option>
                <option value="TON">TON</option>
              </select>
            </div>
            <div className="lxdh">
              <span>Mailbox：</span>
              <input
                type="text"
                className="order-searchinput"
                name="mailbox"
                value={mailbox}
                onChange={this.formComponentChange}
                maxLength={300}
              />
            </div>
            <div className="lxdh">
              <span>Contact Name：</span>
              <input
                type="text"
                className="order-searchinput"
                name="contact_name"
                value={contact_name}
                onChange={this.formComponentChange}
                maxLength={300}
              />
            </div>
            <div className="lxdh">
              <span>Address：</span>
              <input
                type="text"
                className="order-searchinput"
                name="address"
                value={address}
                onChange={this.formComponentChange}
                maxLength={300}
              />
            </div>
            <div className="lxdh">
              <span>Company Name：</span>
              <input
                type="text"
                className="order-searchinput"
                name="company_name"
                value={company_name}
                placeholder="Please enter the name of the contact person for receiving the goods."
                onChange={this.formComponentChange}
                maxLength={300}
              />
            </div>
            <div className="lxdh">
              <span>Telephone No.：</span>
              <input
                type="text"
                className="order-searchinput"
                name="telephone_no"
                value={telephone_no}
                placeholder="Please enter the recipient's contact phone number."
                onChange={this.formComponentChange}
                maxLength={300}
              />
            </div>
            <div className="lxdh">
              <span>Message：</span>
              <textarea
                maxLength={2000}
                placeholder="Enter more detailed information to receive an accurate quote.
        Such as Self Introduction / Grade&amp;Purity / Packing / Payment Term / Other"
                name="message"
                value={message}
                onChange={this.formComponentChange}
              ></textarea>
            </div>
            <p>
              <span>{message.length}</span>/2000
            </p>
          </div>
          <div className="btn-con">
            <button type="submit" className="sc-qr message-add">
              Send
            </button>
          </div>
        </form>
        <Toast text={this.state.toastText} visible={this.state.toastVisible} />
      </div>
        );
    }

    private formComponentChange = (
        event: React.ChangeEvent <
        HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement > ,
    ) => {
        const name = event.target.name as keyof IFormFields;
        const value = event.target.value;

        const newState = {} as Pick < IState,
            keyof IFormFields > ;
        newState[name] = value;

        this.setState(newState);
    };

    private formSubmitHandle = (event: React.FormEvent < HTMLFormElement > ) => {
        event.preventDefault();

        const {
            produc_name,
            contact_name,
            company_name,
            mailbox,
            message,
            quantity,
            telephone_no,
            address,
        } = this.state;
        const rules = [{
                condition: produc_name.trim() === "",
                message: "Please fill in product information！",
            },
            {
                condition: quantity.trim() === "",
                message: "Please fill in the quantity！",
            },
            {
                condition: mailbox.trim() === "",
                message: "Please fill in the email address！",
            },
            // {
            //     condition: !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
            //         mailbox.trim(),
            //     ),
            //     message: "Email can only fill in numbers, letters, and symbols！",
            // },
            {
                condition: !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\..+$/.test(
                    mailbox.trim(),
                ),
                message: "Email can only fill in numbers, letters, and symbols！",
            },
            {
                condition: contact_name.trim() === "",
                message: "Please fill in your name！",
            },
            {
                condition: address.trim() === "",
                message: "Please fill in the address！",
            },
            {
                condition: company_name.trim() === "",
                message: "Please fill in the company name！",
            },
            {
                condition: telephone_no.trim() === "",
                message: "Please fill in the phone number！",
            },
            {
                condition: message.trim() === "",
                message: "Please fill in the information！",
            },
        ];

        for (let i = 0, l = rules.length; i < l; i++) {
            if (rules[i].condition) {
                this.showToastAction(rules[i].message);
                return;
            }
        }

        this.sendFormData()
    };

    private async sendFormData() {
        const r = await request({
            data: {
                lang: 'english',
                produc_name: this.state.produc_name,
                quantity: this.state.quantity,
                unit: this.state.unit,
                mailbox: this.state.mailbox,
                contact_name: this.state.contact_name,
                address: this.state.address,
                company_name: this.state.company_name,
                telephone_no: this.state.telephone_no,
                message: this.state.message,
                shop_id: this.state.shopId,
                goods_id: this.props.goodsId || '0'
            },
            method: "post",
            url: `${config.PHPAPI}api/multi/default/add`,
        });

        if (r.error_code === 0) {
            this.showToastAction("The message has been successfully sent!");
            setTimeout(() => {
                this.setState(this.initState);
            }, 2000);
        } else {
            this.showToastAction(r.message);
        }

    }

    // 隐藏提示框
    private hideToastAction() {
        if (this.toastTimer) {
            clearTimeout(this.toastTimer);
        }
        this.toastTimer = setTimeout(() => {
            this.setState({ toastText: "", toastVisible: false });
        }, 2000);
    }
    /**
     * [显示提示框]
     * @param  text [提示文本]
     */
    private showToastAction(text: string) {
        this.setState({ toastText: text, toastVisible: true });
        this.hideToastAction();
    }

    private async getShopId() {
        const r: any = await utils.getShopInfo();
        this.setState({
            shopId: r.shop_id
        })
    }
}


// WEBPACK FOOTER //
// ./src/containers/shop_en/common/requirements-form/index.tsx